import { parseDateAsLocal } from '@heidi/utils/dates';
import type { IntlShape } from 'react-intl';

/**
 * Formats a date-only string (e.g. a birth date `1994-03-03`) for display in
 * patient metadata lines, locale-aware via `intl.formatDate` (e.g.
 * `03 Mar 1994` in en-AU). Parses as a local calendar day so the date never
 * shifts by timezone. Returns the raw input when it can't be parsed.
 */
export function formatDisplayDate(dateStr: string, intl: IntlShape): string {
  const date = parseDateAsLocal(dateStr);
  if (!date || Number.isNaN(date.getTime())) return dateStr;

  return intl.formatDate(date, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
